import React from 'react';
import { processTextWithReadings } from '../utils/cardUtils';

function TextWithReading({ text, readingPairs, className = '', style = {} }) {
    const segments = processTextWithReadings(text, readingPairs);

    const segmentStyles = {
        display: 'inline-block',
        position: 'relative',
        margin: '0 1px',
        textAlign: 'center',
        verticalAlign: 'bottom'
    };

    const readingStyles = {
        display: 'block',
        fontSize: '0.6em',
        color: '#666',
        lineHeight: '1',
        marginBottom: '2px',
        fontWeight: 'normal'
    };

    const textStyles = {
        display: 'block',
        lineHeight: '1.2'
    };

    const containerStyles = {
        lineHeight: '2',
        ...style
    };

    return (
        <div className={className} style={containerStyles}>
            {segments.map((segment, index) => {
                if (segment.reading) {
                    return (
                        <span key={index} style={segmentStyles}>
                            <span style={readingStyles}>{segment.reading}</span>
                            <span style={textStyles}>{segment.text}</span>
                        </span>
                    );
                } else {
                    return (
                        <span key={index} style={segmentStyles}>
                            <span style={readingStyles}>&nbsp;</span>
                            <span style={textStyles}>{segment.text}</span>
                        </span>
                    );
                }
            })}
        </div>
    );
}

export default TextWithReading;